import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { startSaveEmpresa } from '../../actions/empresas';
import { setMenuLateral } from '../../actions/ui';
import { Ayuda } from './components/Ayuda';
import { General } from './components/General'
import { Idiomas } from './components/Idiomas';
import { Lateral } from './components/Lateral'
import { Legal } from './components/Legal';
import { Personalizacion } from './components/Personalizacion';
import { Reservas } from './components/Reservas';

export const Configuracion = ({ history }) => {
    const dispatch = useDispatch();
    const { empresas } = useSelector(state => state.empresas);
    const { colores } = useSelector(state => state.ui);

    const [objEmpresa, setObjEmpresa] = useState({});
    const [activeComponent, setActiveComponent] = useState('general');
    const [iniciado, setIniciado] = useState(false);
    const [cambiado, setCambiado] = useState(false);

    useEffect(() => {
        if (empresas.length > 0) {
            // Limpiamos cualquier borrador antiguo que pudiera haber quedado en
            // localStorage. Persistir el borrador provocaba que, al volver a
            // entrar, objEmpresa se cargara desde JSON.parse (referencias nuevas
            // en los campos anidados) y la deteccion de cambios lo marcara como
            // modificado sin que el usuario hubiera tocado nada.
            try { localStorage.removeItem('config-empresa-draft'); } catch (e) {}
            setObjEmpresa(empresas[0]);
            setIniciado(true);
        }
    }, [empresas]);

    useEffect(() => {
        const nEmpresa = { ...empresas[0] };
        if (iniciado) {
            let igual = true;
            for (const propiedad in objEmpresa) {
                if (nEmpresa[propiedad] !== objEmpresa[propiedad]) {
                    igual = false;
                }
            }
            setTimeout(() => setCambiado(!igual), 2000);
        }

    }, [iniciado, empresas, objEmpresa]);


    useEffect(() => {
        dispatch(setMenuLateral('configuracion'));
    }, [dispatch]);

    const guardar = () => {
        const objToSave = { ...objEmpresa };
        delete objToSave.smtpPass;
        const original = empresas[0] || {};
        if (String(original.intervaloTiempo) === String(objToSave.intervaloTiempo)) {
            delete objToSave.intervaloTiempo;
        } else if (objToSave.intervaloTiempo != null) {
            objToSave.intervaloTiempo = parseInt(objToSave.intervaloTiempo, 10);
        }
        if (objToSave.diasAntelacionPagoFactorRiesgo != null && objToSave.diasAntelacionPagoFactorRiesgo !== '') {
            const parsed = parseInt(objToSave.diasAntelacionPagoFactorRiesgo, 10);
            objToSave.diasAntelacionPagoFactorRiesgo = !Number.isNaN(parsed) && parsed >= 0 ? parsed : 7;
        }
        try { localStorage.removeItem('config-empresa-draft'); } catch (e) {}
        dispatch(startSaveEmpresa(objToSave));
    }
    const cancelar = () => {
        setObjEmpresa(empresas[0]);
        try { localStorage.removeItem('config-empresa-draft'); } catch (e) {}
    }

    return (
        <div
            className='configuracion'
            style={{
                '--colorPrincipal': colores.colorPrincipal,
                '--colorSecundario': colores.colorSecundario,
                '--color3': colores.color3,
                '--color4': colores.color4,
                '--color5': colores.color5,
                '--color6': colores.color6,
                '--color7': colores.color7,
            }}
        >
            <Lateral
                setActiveComponent={setActiveComponent}
            />
            <div className='principal'>
                {activeComponent === 'general' &&
                    <General
                        objEmpresa={objEmpresa}
                        setObjEmpresa={setObjEmpresa}
                        cambiado={cambiado}
                        guardar={guardar}
                        cancelar={cancelar}
                    />
                }
                {activeComponent === 'reservas' &&
                    <Reservas
                        objEmpresa={objEmpresa}
                        setObjEmpresa={setObjEmpresa}
                        cambiado={cambiado}
                        guardar={guardar}
                        cancelar={cancelar}
                    />
                }
                {activeComponent === 'personalizacion' &&
                    <Personalizacion
                        objEmpresa={objEmpresa}
                        setObjEmpresa={setObjEmpresa}
                        cambiado={cambiado}
                        guardar={guardar}
                        cancelar={cancelar}
						setCambiado={setCambiado}
                    />
                }
                {activeComponent === 'idiomas' &&
                    <Idiomas
                        objEmpresa={objEmpresa}
                        setObjEmpresa={setObjEmpresa}
                        cambiado={cambiado}
                        guardar={guardar}
                        cancelar={cancelar}
                    />
                }
                {activeComponent === 'ayuda' &&
                    <Ayuda
                        objEmpresa={objEmpresa}
                        setObjEmpresa={setObjEmpresa}
                        cambiado={cambiado}
                        guardar={guardar}
                        cancelar={cancelar}
                    />
                }
                {activeComponent === 'legal' &&
                    <Legal />
                }
            </div>
        </div>
    )
}
